import { render } from "./FreebetRestriction.vue?vue&type=template&id=bfbf7da2"
import script from "./FreebetRestriction.vue?vue&type=script&lang=js"
export * from "./FreebetRestriction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__